module.exports = __webpack_public_path__ + "static/media/BnotA.8f85186a.jpg";